import { classes } from 'html-classes';
import { MouseEvent } from 'react';

import { Props as CounterProps } from '~/components/Counter';
import Icon from '~/components/Icon/Icon';

import styles from './FavoriteAddToCartButton.module.scss';

const Counter = ({
  count = 0,
  onClick,
  limit,
  containerClassName,
  buttonClassName,
  countClassName,
  customSize,
}: Omit<CounterProps, 'size' | 'iconSize' | 'disabled'>) => {
  const handleMinusClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();

    if (count <= 0) {
      return;
    }

    onClick?.(count - 1, 'remove', e);
  };

  const handlePlusClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();

    if (count >= limit) {
      return;
    }

    onClick?.(count + 1, 'add', e);
  };

  return (
    <div
      className={classes([styles.counterRoot, containerClassName])}
      onClick={(e) => e.preventDefault()}
    >
      <span
        data-button="minus"
        role="button"
        className={classes([styles.btn, styles.minus, buttonClassName])}
        onClick={handleMinusClick}
      >
        <Icon type="minus-alt" size={24} />
      </span>
      <span className={classes([styles.countNum, countClassName])}>
        {count}
      </span>
      <span
        data-button="plus"
        role="button"
        className={classes([styles.btn, styles.plus, buttonClassName])}
        onClick={handlePlusClick}
      >
        <Icon type="plus-alt" size={customSize ?? 24} />
      </span>
    </div>
  );
};

export default Counter;
